import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/ui/tabs"
import type { ReactNode } from "react"
import { useTabParams } from "@hooks/useTabParams"
import { cn } from "./ui/lib/utils"

type TTabValue = {
  value: string
  name: string
  content: ReactNode
  displayOnly?: ReactNode
}

type TTabsViewProps = {
  tabValues: TTabValue[]
}

export default function TabsView({ tabValues }: TTabsViewProps) {
  const { currentTab, setTab } = useTabParams()
  const activeTab = currentTab || tabValues[0].value

  const clickableTabs = tabValues.filter((tab) => !tab.displayOnly)
  const displayOnly = tabValues.filter((tab) => tab.displayOnly)

  return (
    <Tabs value={activeTab} onValueChange={setTab}>
      <TabsList
        className={cn("tw:flex tw:justify-start", {
          "tw:w-full": displayOnly.length,
        })}
      >
        <div>
          {clickableTabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.name}
            </TabsTrigger>
          ))}
        </div>
        {!!displayOnly.length && <div className="tw:ml-auto" />}

        {displayOnly.map((tab) => (
          <div key={tab.value}>{tab.displayOnly}</div>
        ))}
      </TabsList>
      {tabValues.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="tw:py-2">
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  )
}
